import { IGlobalTeamsState } from '@app/store/modules/global'
import { bindFunctions } from '@app/utils/class'
import { getTeams } from '@app/utils/permissions'
import * as React from 'react'
import { RouteComponentProps, withRouter } from 'react-router-dom'
import { actionCreators, IUserViewState } from '../modules/userView'

type IComponentProps = IUserViewState &
  IGlobalTeamsState &
  RouteComponentProps<{ id: string }> &
  typeof actionCreators

class UserTeams extends React.PureComponent<IComponentProps> {
  public constructor(props: any) {
    super(props)

    bindFunctions(this)
  }

  public render() {
    return (
      <div key={this.props.match.params.id}>
        <div className='mx-2'>{this._renderTeams()}</div>
      </div>
    )
  }

  private _renderTeams() {
    const teams = getTeams(this.props.teams, this.props.item.user).map((item) => {
      return (
        <div key={item} className='d-flex flex-row flex-wrap mt-2'>
          <a
            className='text-primary'
            href={`/admin/teams/${item.id}`}
            style={{ width: '40%', fontWeight: 'bold' }}
          >
            {item.name}
          </a>
          <div>{item.description || 'No Description'}</div>
        </div>
      )
    })

    if (teams.length === 0) {
      return 'No associated teams'
    }

    return <div>{teams}</div>
  }
}

export default withRouter(UserTeams)
